import AdminFooter from "./AdminFooter";

export default AdminFooter;
